/**
 * Created by razial on 16.09.2025.
 */

const IslandDecorationLogic = function (mission) {
    cleverapps.EventEmitter.call(this);
    this.mission = mission;
    this.stagesConfig = mission.stagesConfig.stages;

    const location = cleverapps.meta.getSelectedLocation();

    this.reward = new RewardsList(this.mission.reward, {
        toMainWorld: !location.locationConfig.isMain,
        event: mission.name,
        toBubbleStack: true
    });

    this.load(this.mission.details);
};

IslandDecorationLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
IslandDecorationLogic.prototype.constructor = IslandDecorationLogic;

IslandDecorationLogic.prototype.destructor = function () {
    runCleaners(this);
};

IslandDecorationLogic.prototype.canRemoveSilently = function () {
    return !IslandDecorationHelper.hasWindowBundles(this.period);
};

IslandDecorationLogic.prototype.load = function (data) {
    const currentPeriod = IslandDecorationConfig.getPeriod();

    this.period = data.period || currentPeriod || this.mission.name.replace("IslandDecoration", "").toLowerCase() || undefined;
    this.stage = parseInt(data.stage) || 0;
    this.items = parseInt(data.items) || 0;
    this.rewarded = data.rewarded || false;

    this.shownStage = this.stage;
    this.shownItems = this.items;

    if (!this.rewarded && this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.stage}`, once: true });
    }

    if (this.rewarded || !this.mission.canStart() || this.period !== currentPeriod) {
        this.mission.complete();
    }
};

IslandDecorationLogic.prototype.save = function (details) {
    details.period = this.period || undefined;
    details.stage = this.stage || undefined;
    details.items = this.items || undefined;
    details.rewarded = this.rewarded || undefined;
};

IslandDecorationLogic.prototype.onUpdateMission = function (delta) {
    this.trigger("onStarsChanged", delta);
};

IslandDecorationLogic.prototype.logResultChange = function (delta) {
    if (delta > 0) {
        this.mission.logEvent(Mission.EVENTS.MISSION_POINTS_DAU, { once: true });
    }
};

IslandDecorationLogic.prototype.getStars = function () {
    return this.mission.result;
};

IslandDecorationLogic.prototype.countBoughtItems = function () {
    if (this.isCompleted()) {
        return this.countAllItems();
    }

    return this.stagesConfig.reduce((acc, stage) => acc + stage.items.filter((item) => this.isItemBought(item)).length, 0);
};

IslandDecorationLogic.prototype.countAllItems = function () {
    return this.stagesConfig.reduce((acc, stage) => acc + stage.items.length, 0);
};

IslandDecorationLogic.prototype.getCurrentStage = function () {
    return this.stage;
};

IslandDecorationLogic.prototype.updateShown = function () {
    this.shownStage = this.stage;
    this.shownItems = this.items;

    this.trigger("onItemsShown");
};

IslandDecorationLogic.prototype.hasAttention = function () {
    return this.shownStage !== this.stage || this.shownItems !== this.items;
};

IslandDecorationLogic.prototype.buyItem = function (item) {
    if (!this.canBuyItem(item)) {
        return;
    }

    this.items |= (1 << item.id);

    const stage = this.stagesConfig[item.stage];
    let stageFinished = false;

    if (this.isStageCompleted(stage)) {
        this.mission.logEvent(Mission.EVENTS.MISSION_PROGRESS, { index: this.stage });
        this.mission.logEvent(Mission.EVENTS.MISSION_PROGRESS_DAU, { once: true });

        this.items = 0;
        this.stage += 1;
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.stage}` });

        if (this.isCompleted()) {
            this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
        }

        stageFinished = true;
    }

    this.mission.update(-item.price);

    this.trigger("onItemBought", item);

    if (stageFinished) {
        this.trigger("onStageFinished");
    }
};

IslandDecorationLogic.prototype.canBuyItem = function (item) {
    const period = this.period.charAt(0).toUpperCase() + this.period.slice(1);
    const prefix = `IslandDecoration${period}`;

    if (this.isCompleted()) {
        cleverapps.notification.create(Messages.get(`${prefix}.IsCompleted`));
        return false;
    }

    if (this.isItemBought(item)) {
        cleverapps.notification.create(Messages.get(`${prefix}.IsBought`));
        return false;
    }

    if (this.stage !== item.stage) {
        cleverapps.notification.create(Messages.get(`${prefix}.NotReady`));
        return false;
    }

    if (!this.isEnoughStars(item)) {
        cleverapps.notification.create(Messages.get(`${prefix}.NotEnoughStars`));
        return false;
    }

    return true;
};

IslandDecorationLogic.prototype.getMissionReward = function () {
    return this.reward;
};

IslandDecorationLogic.prototype.receiveMissionReward = function () {
    if (!this.rewarded) {
        this.reward.receiveRewards();

        this.rewarded = true;
        this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, { reward: this.reward });
        this.mission.update();

        this.mission.complete();
    }
};

IslandDecorationLogic.prototype.isMissionRewardReceived = function () {
    return this.rewarded;
};

IslandDecorationLogic.prototype.isEnoughStars = function (item) {
    return this.getStars() >= item.price;
};

IslandDecorationLogic.prototype.isItemBought = function (item) {
    return item.stage < this.stage || item.stage === this.stage && (this.items & (1 << item.id));
};

IslandDecorationLogic.prototype.isItemShown = function (item) {
    return item.stage < this.shownStage || item.stage === this.shownStage && (this.shownItems & (1 << item.id));
};

IslandDecorationLogic.prototype.isStageCompleted = function (stage) {
    return stage.items.every((item) => this.isItemBought(item));
};

IslandDecorationLogic.prototype.isLocked = function (stage) {
    return stage.id > this.getCurrentStage();
};

IslandDecorationLogic.prototype.isCompleted = function () {
    return this.stage >= this.stagesConfig.length;
};

IslandDecorationLogic.prototype.listStages = function () {
    return this.stagesConfig;
};

IslandDecorationLogic.prototype.findMissionRewardSources = function () {
    cleverapps.missionManager.trigger("showPointsSources", this.mission);
};

IslandDecorationLogic.prototype.needToShowRewardTooltip = function () {
    if (cleverapps.tutorial.isActive()) {
        return false;
    }

    const result = this.countBoughtItems() === 0 && this.getStars() === 0 && !this.tooltipShown;
    if (result) {
        this.tooltipShown = true;
    }
    return result;
};

IslandDecorationLogic.prototype.getOrderRewards = function (order) {
    return {
        missionType: this.mission.type,
        amount: this.mission.stagesConfig.calcOrderReward(order)
    };
};

IslandDecorationLogic.prototype.isAttentionRequired = function () {
    if (this.isCompleted()) {
        return false;
    }

    return this.stagesConfig[this.stage].items.filter((item) => !this.isItemBought(item) && this.isEnoughStars(item)).length;
};

IslandDecorationLogic.prototype.calcNextPrice = function () {
    if (this.isCompleted()) {
        return 0;
    }

    const element = this.stagesConfig[this.stage].items.find((item) => !this.isItemBought(item));
    return element.price;
};

IslandDecorationLogic.findRunningMission = function () {
    const types = [
        Mission.TYPE_ISLAND_DECORATION
    ];

    for (let i = 0; i < types.length; i++) {
        const mission = cleverapps.missionManager.findRunningMission(types[i]);
        if (mission) {
            return mission;
        }
    }
};
